import React, { ChangeEvent, useState } from "react";
import CustomButton from "../common/CustomBtn";
import { useTranslation } from "react-i18next";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { sendMessage } from "../../helpers/xhr";
import { MdPhoneCallback, MdMail } from "react-icons/md";

const to = process.env.REACT_APP_TO_EMAIL || "";

export default function ContactForm() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<{
    open: boolean;
    message: string;
    type: "success" | "error";
  }>({
    open: false,
    message: "",
    type: "success",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);
    setAlert({ open: false, message: "", type: "success" });

    try {
      const subject = `New message from ${formData.fullName}`;
      await sendMessage(to, subject, formData);
      setAlert({
        open: true,
        message: t("footerTranslate.contactForm.message_sent"),
        type: "success",
      });
      setFormData({ fullName: "", email: "", message: "" });
    } catch (error) {
      console.error("Error sending email", error);
      setAlert({
        open: true,
        message: t("footerTranslate.contactForm.message_failed"),
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="justify-between w-full mb-8 md:flex">
      <div>
        <ul className="text-[14px]">
          <li className="pb-5 sm:text-[18px] font-semibold">
            {t("footerTranslate.safe_coatings_manager")}
          </li>
          <li className="pb-1 font-semibold">{t("footerTranslate.manager")}</li>
          <li className="pb-1">Andrius Vaitkus</li>
          <li className="flex items-center gap-2 pb-1">
            <MdPhoneCallback /> <span>+370 6141 3680</span>
          </li>
          <li className="flex items-center gap-2 ">
            <MdMail />{" "}
            <a
              href="mailto:andrius.vaitkus@economus.lt"
              target="_blank"
              className="underline transition-transform duration-300 transform hover:text-tertiary"
              rel="noreferrer"
            >
              Andrius.vaitkus@economus.lt{" "}
            </a>
          </li>
        </ul>
      </div>

      <div className=" md:w-3/5 mt-12 md:mt-0">
        <div className="flex flex-col ">
          <div>
            <p className="pb-2 sm:text-[18px] max-w-[225px] font-semibold">
              {t("footerTranslate.contactForm.send_message")}
            </p>
          </div>

          <div className="w-full">
            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-5 text-black"
            >
              <div className="flex gap-2">
                <div className="flex flex-col w-full">
                  <label
                    htmlFor="fullName"
                    className="mb-1 text-[14px] font-medium text-white "
                  >
                    {t("footerTranslate.contactForm.full_name")}
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="w-full p-2 h-[56px] rounded-md border border-gray-300"
                    required
                  />
                </div>
                <div className="flex flex-col w-full">
                  <label
                    htmlFor="email"
                    className="mb-1 text-white text-[14px] font-medium "
                  >
                    {t("footerTranslate.contactForm.email")}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-2 h-[56px] rounded-md border border-gray-300"
                    required
                  />
                </div>
              </div>

              <div className="flex flex-col w-full">
                <label
                  htmlFor="message"
                  className="mb-1 text-white text-[14px] font-medium "
                >
                  {t("footerTranslate.contactForm.message")}
                </label>
                <textarea
                  id="message"
                  name="message"
                  maxLength={500}
                  rows={5}
                  cols={50}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="shadow appearance-none border rounded h-[140px] w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>

              <div className="w-full">
                <CustomButton
                  width="100%"
                  bg="primary.light"
                  type="submit"
                  disabled={loading}
                >
                  {loading
                    ? t("footerTranslate.contactForm.sending")
                    : t("footerTranslate.contactForm.button_text")}
                </CustomButton>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert
          severity={alert.type}
          onClose={() => setAlert({ ...alert, open: false })}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
